module.exports = __webpack_public_path__ + "52e88f48cdffd84ec73174a0b8c21514.fbx";